export const calculateBatchAllocation = (batches, requestedQuantity) => {
    if (!batches || batches.length === 0 || requestedQuantity <= 0) {
        return { 
            allocations: [], 
            hasInsufficientStock: false, 
            availableStock: 0, 
            requestedQuantity 
        };
    }

    // It checks for "RETURNED" batches first, then it sorts by expiry date
    const availableBatches = batches
        .filter(batch => batch.current_stock > 0)
        .sort((a, b) => {
            if (a.batch_number === "RETURNED" && b.batch_number !== "RETURNED") return -1;
            if (a.batch_number !== "RETURNED" && b.batch_number === "RETURNED") return 1;
            return new Date(a.expiry_date) - new Date(b.expiry_date);
        });

    const totalAvailableStock = availableBatches.reduce((sum, batch) => sum + batch.current_stock, 0);
    
    if (totalAvailableStock < requestedQuantity) {
        return { 
            allocations: [], 
            hasInsufficientStock: true,
            availableStock: totalAvailableStock,
            requestedQuantity
        };
    }

    const allocations = [];
    let remainingQuantity = requestedQuantity;

    for (const batch of availableBatches) {
        if (remainingQuantity <= 0) break;

        const quantityFromBatch = Math.min(batch.current_stock, remainingQuantity);
        allocations.push({
            batchNumber: batch.batch_number,
            quantity: quantityFromBatch,
            expiryDate: batch.expiry_date,
            unitCost: batch.buying_price,
            sellingPrice: batch.selling_price
        });

        remainingQuantity -= quantityFromBatch;
    }

    return { allocations, hasInsufficientStock: false };
}; 

export const getBatchWeightedSellingPrice = (allocations) => {
    if (!Array.isArray(allocations) || allocations.length === 0) return null;

    let totalQuantity = 0;
    let totalPrice = 0;

    for (const allocation of allocations) {
        const quantity = Number(allocation.quantity);
        const sellingPrice = Number(allocation.sellingPrice);
        if (!Number.isFinite(quantity) || quantity <= 0 || !Number.isFinite(sellingPrice)) {
            return null;
        }
        totalQuantity += quantity;
        totalPrice += sellingPrice * quantity;
    }

    return totalQuantity > 0 ? totalPrice / totalQuantity : null;
};